import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import PropTypes from "prop-types";
import parse from "html-react-parser";

function HfnTabs(props) {
  const { Title, Panel } = props;

  return (
    <TabView id="Hfntabs" className={`${Title}_wrapper`}>
      {Panel?.map((item) => {
        return (
          <TabPanel id={item?.id} header={item?.Title} key={item?.id}>
            {item?.Description && parse(item?.Description)}
          </TabPanel>
        );
      })}
    </TabView>
  );
}

HfnTabs.propTypes = {
  /**
   * Title is wrapper for overall component
   * */
  Title: PropTypes.string.isRequired,
  /**
   * Panel is actual list of data for component
   * */
  Panel: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      Title: PropTypes.string.isRequired,
      Description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default HfnTabs;
